import React from "react";
import {
  HeaderContainer,
  HeaderContent,
  HeaderLeftSection,
  HeaderRightSection,
} from "./styled";

interface CardHeaderProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

const CardHeader = ({ left, right }: CardHeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderContent>
        <HeaderLeftSection>{left}</HeaderLeftSection>
        <HeaderRightSection>{right}</HeaderRightSection>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default CardHeader;
